import * as React from 'react';
import { Route, Switch, Redirect, useLocation } from 'react-router';
import { useSelector } from 'react-redux';
const Dashboard = React.lazy(() => import('../components/pages/Dashboard'));
const EditChart = React.lazy(() => import('../components/pages/Play/EditChart'));
const AllDashboards = React.lazy(() => import('../components/pages/alldashboard/AllDashboards'));
const BiddingManagement = React.lazy(() =>
  import('../components/pages/RFQ/RFQBidding/BiddingManagement/BiddingManagement')
);
// tslint:disable-next-line: ter-func-call-spacing
const ExceptionRuleListPage = React.lazy(() =>
  import('../components/pages/Exceptions/ExceptionRuleList/ExceptionRuleListPage')
);
const AirCargoDetailsPage = React.lazy(() => import('../components/pages/AirCargo/AirCargoDetailsPage'));
const ExceptionAlertDefinitionsPage = React.lazy(() =>
  import('../components/pages/Exceptions/ExceptionAlertList/ExceptionAlertDefinitionsPage')
);
const ExceptionAlertInstancesPage = React.lazy(() =>
  import('../components/pages/Exceptions/ExceptionAlertList/ExceptionAlertInstancesPage')
);
const ExceptionAlertInstanceDetails = React.lazy(() =>
  import('../components/pages/Exceptions/ExceptionAlertList/ExceptionAlertInstanceDetails')
);
const bulkUpload = React.lazy(() =>
  import('../components/pages/Container/CreateBulkShipment/CreateBulkShipmentPage')
);
const Account = React.lazy(() => import('../components/pages/Account'));
const CustomConfig = React.lazy(() => import('../components/pages/CustomConfig/CustomConfig'));
const CreateUserNew = React.lazy(() => import('../components/pages/createUserNew/CreateUserNew'));
const Suspense = React.Suspense;
const Organisation = React.lazy(() =>
  import('../components/pages/Organisation/OrganisationProfile')
);
// tslint:disable-next-line: max-line-length
const TeamManagement = React.lazy(() =>
  import('../components/pages/TeamManagement/TeamManagement')
);
const UserManagement = React.lazy(() =>
  import('../components/pages/UserManagement/UserManagement'));
const TermsAndConditions = (React as any).lazy(() =>
  import('src/components/pages/TermsAndConditions/Index'));
const ChargeMaster = (React as any).lazy(() =>
  import('src/components/pages/ChargeMaster/Index'));
const ApprovalPolicies = (React as any).lazy(() =>
  import('src/components/pages/ApprovalPolicies/Index'));
const MyApprovals = (React as any).lazy(() =>
  import('src/components/pages/MyApprovals/Index'));
const NotificationsPage = React.lazy(() => import('../components/pages/Notifications/NotificationsPage'));
const Imports = React.lazy(() => import('../components/pages/imports/Imports'));
const AirCargo = React.lazy(() => import('../components/pages/AirCargo/AirCargo'));
const CreateExceptionRuleModal = React.lazy(() =>
  import('../components/pages/Exceptions/CreateExceptionRule/CreateExceptionRuleModal')
);
const WrapperExceptionRuleEdit = React.lazy(() =>
  import('../components/pages/Exceptions/CreateExceptionRule/WrapperExceptionRuleEdit')
);
const ContainerTrackingPage = React.lazy(() =>
  import('../components/pages/Container/ShipmentTrackingPage')
);
const ContainerDetailsMainPage = React.lazy(() =>
  import('../components/pages/Container/ContainerDetailsWithPermission')
);
const ImportDetails = React.lazy(() => import('../components/pages/imports/ImportDetails'));
const Permissions = React.lazy(() => import('../components/pages/permissions/Permissions'));
const ExportDetails = React.lazy(() => import('../components/pages/exports/ExportDetails'));
const Exports = React.lazy(() => import('../components/pages/exports/Exports'));
const Triangulation = React.lazy(() => import('../components/pages/Triangulation/ContainerTriangulation'));
const RFQManagement = React.lazy(() =>
  import('../components/pages/RFQ/RFQManagement/RFQManagement')
);
const RfqRateMaster = React.lazy(() => import('../components/pages/RfqRateMaster/RfqRateMaster'));
const TasksWorkflow = React.lazy(() => import('../components/pages/TasksWorkflow/TasksWorkflowPage'));
const RfqBulkRequest = React.lazy(() =>
  import('../components/pages/BulkRequest/BulkActionAndDownload/RfqBulkRequest')
);
const RFQLineItemsBidsContext = React.lazy(() =>
  import('../components/pages/RFQ/RFQPlanDetails/RFQLineItemsBidsContext')
);
const RfqFlexibleReports = React.lazy(() =>
  import('../components/pages/RFQ/FlexibleReports/FlexibleReports')
);
const BiddingDetails = React.lazy(() =>
  import('../components/pages/RFQ/RFQBidding/BiddingDetails')
);
const RfqAnalytics = React.lazy(() => import('../components/pages/RFQ/RfqAnalytics'));
// RFQ Next (revamp) — Phase 0
const RFQNextManagement = React.lazy(() =>
  import('../components/pages/RFQNext/RFQManagement/RFQManagement')
);
const TenderLineItemsQuotesContext = React.lazy(() =>
  import('../components/pages/RFQNext/TenderDetails/TenderLineItemsQuotesContext')
);
const RFQNextVendorManagement = React.lazy(() =>
  import('../components/pages/RFQNext/RFQVendor/QuoteManagement/QuoteManagement')
);
const RFQNextVendorDetails = TenderLineItemsQuotesContext;
const DefaultPage = React.lazy(() => import('../components/common/DefaultPage'));
const Feed = React.lazy(() => import('../components/pages/CustomerFeedback/Feed'));
// const AddEditLineItems = React.lazy(() => import('../components/pages/RFQ/AddEditRFQLineItem/AddEditLineItems'));
const MastersCHA = React.lazy(() => import('../components/pages/masters/Masters')
.then(module => ({ default: module.MastersCHA })));
const MastersShippingLine = React.lazy(() => import('../components/pages/masters/Masters')
.then(module => ({ default: module.MastersShippingLine })));
const MastersChildStakeholders = React.lazy(() => import('../components/pages/masters/Masters')
.then(module => ({ default: module.MastersChildStakeholders })));
const MastersShipper = React.lazy(() => import('../components/pages/masters/Masters')
.then(module => ({ default: module.MastersShipper })));
const MastersFF = React.lazy(() => import('../components/pages/masters/Masters')
.then(module => ({ default: module.MastersFF })));
const MastersCustomer = React.lazy(() => import('../components/pages/masters/Masters')
.then(module => ({ default: module.MastersCustomer })));
const MastersSupplier = React.lazy(() => import('../components/pages/masters/Masters')
.then(module => ({ default: module.MastersSupplier })));
const MasterProducts = React.lazy(() => import('../components/pages/masters/Masters')
.then(module => ({ default: module.Products })));
const MasterAddress = React.lazy(() => import('../components/pages/masters/Masters')
.then(module => ({ default: module.MasterAddress })));
const MasterDocument = React.lazy(() => import('../components/pages/masters/Masters')
.then(module => ({ default: module.MasterDocument })));
const RegionsTemplate = React.lazy(() => import('../components/pages/masters/RegionsTemplate/RegionsTemplate'));

import Loader from 'src/components/common/Loader';
import DiscoverRatePage from 'src/components/pages/DiscoverRate/DiscoverRatePage';
import { CombinedReducerTypes } from 'src/reducers';
import InquiryDetail from 'src/components/pages/Enquiry/InquiryDetail';
import InquiryMain from 'src/components/pages/Enquiry/InquiryMain';
import SharedPage from 'src/components/pages/SharedPage';
import SEIndexPage from 'src/components/pages/shipment-execution/SEIndexPage';
import { ANALYTICS_BASE_PATH } from '../globals';
const CreateBidFF = React.lazy(() =>
  import('src/components/pages/Enquiry/CreateBidFF/CreateBidFF')
);
const TrackingApiDocs = React.lazy(() =>
  import('src/components/pages/Container/TrackingApiDocs/TrackingApiDocs')
);
const CreateShipment = React.lazy(() =>
  import('src/components/pages/Container/UnifiedShipmentView/CreateShipment')
);
const DsrTemplate = React.lazy(() =>
  import('src/components/pages/masters/DsrTemplate/DsrTemplate')
);

const DsrTemplateCreate = React.lazy(() => 
  import('src/components/pages/masters/DsrTemplate/NewTemplate')
);
const CreateEnquiry = React.lazy(() => import('src/components/pages/Enquiry/CreateEnquiry'));
const Invoice = (React as any).lazy(() => import('src/components/pages/invoicing/InvoicingMain'));
const CreateNewInvoice = (React as any).lazy(() =>
  import('src/components/pages/invoicing/CreateNewInvoice/view')
);
const InvoiceActivity = (React as any).lazy(() =>
  import('src/components/pages/invoicing/InvoiceActivity')
);
const InvoiceAgeingView = (React as any).lazy(() =>
  import('src/components/pages/invoicing/InvoiceAgeingView')
);
const RateMaster= (React as any).lazy(() => import('src/components/pages/RateMaster/RateMaster'));
const BulkRequest = (React as any).lazy(() =>
  import('src/components/pages/BulkRequest/BulkRequests')
);
const MarkupAutomationTool = (React as any).lazy(() =>
  import('src/components/pages/MarkupAutomationTool/MarkupAutomationTool')
);
const VesselSchedules = (React as any).lazy(() =>
  import('src/components/pages/VesselSchedules/VesselSchedules')
);
const DemurrageAndDetention = React.lazy(() =>
  import('src/components/pages/DemurrageAndDetention/DemurrageAndDetention')
);

const PortGroups = React.lazy(() => import('src/components/pages/PortGroups/PortGroups'));
const QueryBuilder = React.lazy(() => import('src/components/pages/queryBuilder/queryBuilder'));

const MyPlan = React.lazy(() => import('src/components/pages/SubscriptionPlan/MyPlan'));

// const Home = React.lazy(() => import('src/components/pages/Home/Home'));

const RouterOutlet = (props) => {
  const passwordExpired = useSelector(
    (s: CombinedReducerTypes) => s.logoutReducer.passwordExpired === true,
  );
  const location = useLocation();
  const FORCED_PATH = '/account';
  const isOnForcedScreen =
    location.pathname === FORCED_PATH &&
    new URLSearchParams(location.search).get('forceChangePassword') === '1';

  if (passwordExpired && !isOnForcedScreen) {
    return <Redirect to={`${FORCED_PATH}?forceChangePassword=1`} />;
  }

  return (
  <Suspense fallback={<Loader />}>
    <Switch>
      <Route path="/dashboard" component={Dashboard} />
      {/* <Route path="/present" component={Present} /> */}
      <Route path="/alldashboards" component={AllDashboards} />
      <Route path="/slice/:sliceId/edit" component={EditChart} />
      <Route path="/exceptionrules" component={ExceptionRuleListPage} />
      <Route path="/exceptionrule/create" component={CreateExceptionRuleModal} />
      <Route path="/exceptionrule/edit/:ruleId" component={WrapperExceptionRuleEdit} />
      <Route path="/alerts/definitions" component={ExceptionAlertDefinitionsPage} />
      <Route path="/alerts/instances" component={ExceptionAlertInstancesPage} />
      <Route path="/alerts/instance/:instanceId"
        component={ExceptionAlertInstanceDetails}></Route>
      <Route exact path="/imports" component={Imports} />
      <Route exact path="/airCargo/airCargo" component={AirCargo} />
      <Route exact path="/airCargo/freightForwarder" component={AirCargo} />
      <Route path="/imports/detail/:importId" component={ImportDetails} />
      <Route exact path="/exports" component={Exports} />
      <Route path="/exports/detail/:exportId" component={ExportDetails} />
      <Route exact path="/permissions" component={Permissions} />
      <Route path="/account" component={Account} />
      <Route path="/customConfig" component={CustomConfig} />
      <Route exact path="/teams" component={TeamManagement} />
      <Route exact path="/tasks-workflow" component = {TasksWorkflow} />
      <Route exact path="/users" component={UserManagement} />
      <Route exact path="/tnc" component={TermsAndConditions} />
      <Route exact path="/chargeMaster" component={ChargeMaster} />
      <Route exact path="/approval-policies" component={ApprovalPolicies} />
      <Route exact path="/my-approvals" component={MyApprovals} />
      <Route path="/users/create" component={CreateUserNew} />
      <Route path="/user/edit/:id" component={CreateUserNew} />
      <Route path="/container/detail/:shipmentType/:id/:tabId?/:containerId?"
        component={ContainerDetailsMainPage} />
      <Route path="/import/container/detail/:id/:tabId?"
        component={ContainerDetailsMainPage} />
      <Route path="/export/container/detail/:id/:tabId?"
        component={ContainerDetailsMainPage} />
      <Route path="/track/createBulkShipment" exact component={bulkUpload}/>
      <Route path="/track/create" exact component={CreateShipment} />
      <Route path="/track/edit/:shipmentId" exact component={CreateShipment} />
      <Route path="/track/:tabId" exact component={ContainerTrackingPage} />
      <Route path="/import/container/tab/:tabId" exact key="import-container"
        component={ContainerTrackingPage} />

        {/*  Enquiry Routes */}

        <Route
          path="/inquiry/details/shipper/:inquiryId/tab/:tabId/:bidId?"
          exact
          component={() => <InquiryDetail type={'SHIPPER'} />}
        />

        <Route
          path="/inquiry/details/ff/:inquiryId/tab/:tabId/:bidId?"
          exact
          component={() => <InquiryDetail type={'FF'} />}
        />

        <Route
          path="/inquiry/shipper"
          exact
          component={(routeProps) => (
            <InquiryMain {...routeProps} tkey="INQUIRY" viewType={'SHIPPER'} />
          )}
        />
        <Route path="/inquiry/shipper/createInquiry" exact component={CreateEnquiry} />
        <Route path="/inquiry/shipper/createInquiry/:inquiryId" exact component={CreateEnquiry} />
        <Route path="/inquiry/shipper/edit/:inquiryId" exact component={CreateEnquiry} />
        <Route path="/inquiry/shipper/addOfflineBid/:inquiryId" exact component={CreateBidFF} />

        <Route
          path="/inquiry/ff"
          exact
          component={(routeProps) => (
            <InquiryMain {...routeProps} viewType={'FF'} tkey="INQUIRY" />
          )}
        />
        <Route
          path="/inquiry/ff/createbid/:inquiryId"
          exact
          key="createbid"
          component={CreateBidFF}
        />
        <Route
          path="/inquiry/ff/editbid/:inquiryId/:bidId"
          exact
          key="editbid"
          component={CreateBidFF}
        />

        <Route
          path="/organisation/:orgType?/:orgId?"
          component={(routeProps) => (
            <Organisation
              {...routeProps}
              key={routeProps.match.params ? routeProps.match.params.orgId : 'admin'}
            />
          )}
        />

      <Route exact path="/masters/CHA"
        component={routeProps => <MastersCHA {...routeProps} key={'CHA'} />} />
      <Route exact path="/masters/VENDOR"
        component={routeProps => <MastersFF {...routeProps} key={'FF'} />} />
      <Route exact path="/masters/SHIPPER"
        component={routeProps => <MastersShipper {...routeProps} key={'SHIPPER'} />} />
      <Route exact path="/masters/CHILD"
        component={routeProps => <MastersChildStakeholders {...routeProps} key={'CHILD'} />} />
      <Route exact path="/masters/SHIPPING_LINE"
        component={routeProps => <MastersShippingLine {...routeProps} key={'SHIPPING_LINE'} />} />
      <Route exact path="/masters/CUSTOMER"
        component={routeProps => <MastersCustomer {...routeProps} key={'CUSTOMER'} />} />
      <Route exact path="/masters/SUPPLIER"
        component={routeProps => <MastersSupplier {...routeProps} key={'SUPPLIER'} />} />
      <Route exact path="/masters/product"
        component={props => <MasterProducts {...props} key={'PRODUCT'} />} />
      <Route exact path="/masters/address"
        component={props => <MasterAddress {...props} key={'ADDRESS'} />} />
      <Route exact path="/masters/document"
        component={routeProps => <MasterDocument {...routeProps} key={'DOCUMENT'} />} />
      
      <Route path="/masters/regions" exact component={RegionsTemplate}></Route>

        <Route path="/rfq/locals/ratemaster" exact component={RfqRateMaster}></Route>
        {/* RFQ Next (revamp) — shipper routes */}
        <Route path="/rfq/shipper" exact component={RFQNextManagement}></Route>
        <Route
          path="/rfq/shipper/lineItems/:tab"
          exact
          component={(routeProps) => (
            <TenderLineItemsQuotesContext {...routeProps} bidLineItem="LINE_ITEMS" viewMode="ALL" />
          )}
        />
        <Route
          path="/rfq/shipper/detail/:tab/:tenderId"
          exact
          component={(routeProps) => (
            <TenderLineItemsQuotesContext {...routeProps} bidLineItem="LINE_ITEMS" viewMode="SINGLE" />
          )}
        />
        {/* Old shipper (preserved for reference) */}
        <Route path="/rfq/old/shipper" exact component={RFQManagement}></Route>
        <Route
          path="/rfq/old/shipper/lineItems/:tab"
          exact
          component={(routeProps) => (
            <RFQLineItemsBidsContext {...routeProps} bidLineItem="LINE_ITEMS" viewMode="ALL" />
          )}
        />
        <Route
          path="/rfq/old/shipper/detail/:tab/:rfqPlanId"
          exact
          component={(routeProps) => (
            <RFQLineItemsBidsContext {...routeProps} bidLineItem="LINE_ITEMS" viewMode="SINGLE" />
          )}
        />
        <Route path="/rfq/flexibleReports" exact component={RfqFlexibleReports}></Route>
        <Route path="/airCargo/details/:id" exact component={AirCargoDetailsPage}></Route>
        <Route path="/freightForwarder/details/:id" exact component={AirCargoDetailsPage}></Route>
        {/* RFQ Next (revamp) — vendor routes */}
        <Route path="/rfq/vendor" exact component={RFQNextVendorManagement}></Route>
        <Route
          path="/rfq/vendor/details/:rfqPlanId"
          component={(routeProps) => (
            <RFQNextVendorDetails {...routeProps} viewMode="SINGLE" />
          )}
        />
        {/* Old vendor (preserved for backward compatibility) */}
        <Route path="/rfq/bidding" exact component={BiddingManagement}></Route>
        <Route path="/rfq/analytics" exact component={RfqAnalytics}></Route>
        <Route path="/biddingDetails/:rfqPlanId" component={BiddingDetails}></Route>
        <Route path="/customerActivity" component={Feed}></Route>
        <Route path="/allDashboards" component={AllDashboards} />
        <Route
          path="/booking/shipper/:bookingId?/:bookingNumber?"
          component={(routeProps) => (
            <InquiryMain {...routeProps} viewType={'SHIPPER'} tkey="BOOKING" />
          )}
        />
        <Route
          path="/booking/ff/:bookingId?/:bookingNumber?"
          component={(routeProps) => (
            <InquiryMain {...routeProps} viewType={'FF'} tkey="BOOKING" />
          )}
        />
        <Route
          path="/execution/shipper/:shipmentId?/:shipmentNumber?/:action?"
          exact
          component={(routeProps) => (
            <SEIndexPage {...routeProps} type={'SHIPPER'} tkey="SHIPMENT" />
          )}
        />
        <Route
          path="/execution/ff/:shipmentId?/:shipmentNumber?/:action?"
          exact
          component={(routeProps) => (
            <SEIndexPage {...routeProps} type={'FF'} tkey="SHIPMENT" />
          )}
        />
        <Route
          path="/:orgType/notifications"
          exact
          component={(routeProps) => <NotificationsPage {...routeProps} />}
        />
        <Route path="/invoice/payables/:invoiceId?" exact component={Invoice} />
        <Route path="/invoice/receivables/:invoiceId?" exact component={Invoice} />
        <Route path="/invoice/create/:sourceType?/:sourceId?" exact component={routeProps => <CreateNewInvoice {...routeProps} routeType="create"/>} />
        <Route path="/invoice/resolve/:invoiceId" exact component={routeProps => <CreateNewInvoice {...routeProps} routeType="resolve"/>} />
        <Route path="/invoice/activity/:type" exact component={InvoiceActivity} />
        <Route path="/invoice/view/:invoiceId" exact component={routeProps => <CreateNewInvoice {...routeProps} routeType="view"/>} />
        <Route path="/invoice/review/:invoiceId" exact component={routeProps => <CreateNewInvoice {...routeProps} routeType="review"/>} />
        <Route path="/invoice/ageingview/:type" exact component={InvoiceAgeingView} />
        <Route path="/bulkRequest/:activeTab?" exact component={BulkRequest} />
        <Route path="/discover-:viewType-rates" exact component={DiscoverRatePage} />
        <Route path="/discover-rates" exact component={DiscoverRatePage} />
        <Route path="/rateMaster" exact component={RateMaster} />
        <Route path="/dsr/template" exact component={DsrTemplate} />
        <Route path="/dsr/template/create" exact component={DsrTemplateCreate} />
        <Route path="/markup" exact component={MarkupAutomationTool} />
        <Route path="/vessel-schedules" exact component={VesselSchedules} />
        <Route path="/sharing-module/:sharingId" exact component={SharedPage} />
        <Route exact path="/triangulation" component={routeProps => <Triangulation {...routeProps} />} />
        {/* <Route path="/home" exact component={Home} /> */}
        <Route path="/api" exact component={TrackingApiDocs} />
        <Route path="/subscription-plan" exact component={MyPlan} />
        <Route path="/demurrage-and-detention" exact component={DemurrageAndDetention} />

        <Route path={`${ANALYTICS_BASE_PATH}`} component={QueryBuilder}/>

        <Route path="/port-groups" exact component={PortGroups}/>
        
        <Route component={DefaultPage} />
      </Switch>
    </Suspense>
  );
};

export default RouterOutlet;
